import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { isAxiosError } from "axios";
import { ChatbotMessage } from "@ac-expo/api-types";

const getChatbotMessages = async () => {
  try {
    const { data } =
      await privateAxios.get<Omit<ChatbotMessage, "state">[]>(`/chatbot`);

    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        message: error.response?.data.message,
      };
    }
    throw error;
  }
};

export const useChatbotMessages = () => {
  return useQuery({
    queryKey: ["chatbot-messages"],
    queryFn: getChatbotMessages,
  });
};
